import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import FormGraphConfiguration from 'dashboard/forms/FormGraphConfiguration';
import { AccountType } from 'dashboard/models/account-type';
import { Graph, GraphAttributes } from 'dashboard/models/graph';
import { GraphDatumTypeAttributes } from 'dashboard/models/graph-datum-type';

export interface DashboardGraphConfigViewProps {
  graph: Graph;
  accountTypes: AccountType[];
  loading: boolean;
  handleGraphConfigSubmit: (config: GraphAttributes) => Promise<void>;
  handleCreateGraphDatumType: (config: GraphDatumTypeAttributes) => Promise<void>;
  isSubmittingForm: boolean;
  isSubmittingNewNodeForm: boolean;
}

const DashboardGraphConfigView = ({
  graph,
  loading,
  handleGraphConfigSubmit,
  handleCreateGraphDatumType,
  isSubmittingNewNodeForm,
  accountTypes,
}: DashboardGraphConfigViewProps) => {
  return loading || !graph ? (
    <LoadingIndicator />
  ) : (
    <FormGraphConfiguration
      onSubmit={handleGraphConfigSubmit}
      handleCreateGraphDatumType={handleCreateGraphDatumType}
      initialValues={graph.attributes}
      isSubmittingNewNodeForm={isSubmittingNewNodeForm}
      accountTypes={accountTypes}
      presetSummaries={graph?.attributes['preset-summaries']}
    />
  );
};

export default DashboardGraphConfigView;
